module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("FOREWORD")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/s.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEN")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALTER")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTH")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSUMED")]), _vm._v(" the presidency of the Chicago Jewish Historical Society, it was expected that he would provide each issue of the Society’s quarterly with a short personal message from the president, a common feature in such publications. This he has done regularly with topics of interest and worth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Walter Roth is not a typical organization president, a man with mere leadership abilities. He is a gifted writer with unusual research ability and an abiding interest in Chicago Jewry. This combination of talents has resulted, in addition to his messages, in a steady stream of vigorous articles on different aspects of the Chicago Jewish experience. His interests have led him, and us, into many fascinating and unexplored byways. He has opened doors and lifted curtains on obscure, half-forgotten and sometimes hidden incidents. He has introduced us to a broad variety of characters, a few of whom we may be glad we never met but who too are part of our history. His research activities have already resulted in one well-received book, "), _c('em', [_vm._v("An Accidental Anarchist.")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("This felicitous selection of stories, written during the past fifteen years, provides interesting and valuable insights into local Jewish history. Those accustomed to thinking of history mainly in terms of organizations, institutions and momentous events will be reminded that, in ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("the end, history is people. The reader will meet some of the most colorful and interesting of them in these pages.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("Irwin Suloway")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("Professor Emeritus")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("Chicago-State University")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512e9ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Foreword.vue
// module id = 72
// module chunks = 0